import type {FilePagePayload} from '@github-ui/code-view-types'
import {extractPathFromPathname} from '@github-ui/paths'
import {useNavigationError} from '@github-ui/react-core/use-navigation-error'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {useState} from 'react'

import {makeErrorPayload} from '../utilities/make-payload'

export function useFilePagePayload(initialPayload?: FilePagePayload): FilePagePayload {
  const routePayload = useRoutePayload<FilePagePayload>()
  let payload = initialPayload || routePayload
  // we assume that the first payload is always good
  const [lastGoodPayload, setLastGoodPayload] = useState(payload)
  const error = useNavigationError()

  if (!payload) {
    const newPath = extractPathFromPathname(location.pathname, lastGoodPayload.refInfo.name, lastGoodPayload.path)
    payload = makeErrorPayload(lastGoodPayload, error, newPath)
  } else if (payload !== lastGoodPayload) {
    setLastGoodPayload(payload)
  }
  return payload
}
